module.exports = __webpack_public_path__ + "static/new-slider-three-a13ced9b764ae6eb871f5013ae81ea8d.png";